import type * as React from 'react'
import { Switch } from './switch.js'

export interface ToggleFieldProps {
  label: string
  description: string
  checked: boolean
  onChange: (checked: boolean) => void
  /**
   * Which state draws the eye: 'on' (the default) tints the card while it is on; 'off' tints it while it is
   * off, for a switch we want people to turn on.
   */
  emphasis?: 'on' | 'off'
  children?: React.ReactNode
}

const ORANGE_CARD = 'border-[#f97316]/50 bg-[#f97316]/10'
const PLAIN_CARD = 'border-border bg-input/50 hover:border-hover hover:bg-input/80'

export function ToggleField({
  label,
  description,
  checked,
  onChange,
  emphasis = 'on',
  children,
}: ToggleFieldProps) {
  const tinted = emphasis === 'on' ? checked : !checked
  return (
    <div className={`rounded-xl border transition-colors ${tinted ? ORANGE_CARD : PLAIN_CARD}`}>
      <button
        type="button"
        className="flex w-full cursor-pointer items-center justify-between gap-6 p-4 text-left"
        onClick={() => onChange(!checked)}
      >
        <div className="min-w-0 flex-1">
          <p className="font-medium text-white">{label}</p>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
        <Switch checked={checked} onCheckedChange={onChange} />
      </button>
      {children && <div className="px-4 pb-4 pt-0">{children}</div>}
    </div>
  )
}
